import { SET_POPUP_NOTIFICATION, SET_TOAST_NOTIFICATION } from "../../actionTypes/actionsTypes";
import { AppAction } from "../../types";

// toast notification action
export const setToastNotification = (message: string, type: "info" | "success" | "warning" | "default" | "error"): AppAction => ({
    type: SET_TOAST_NOTIFICATION,
    payload: { data: {message: message, type: type}}
});

export const setLargeToast = (message: string, type: "success" | "error", show: boolean): AppAction => ({
    type: SET_POPUP_NOTIFICATION,
    payload: { data: {message: message, type: type, show: show}}
})